import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';

import { AppConfig } from 'src/app/app.config';
import { SelectListItem } from './select-list.model';

@Injectable({
    providedIn: 'root'
})
export class SelectListService {

    private customerAdminUri: string = '';

    constructor(
        private config: AppConfig,
        private http: HttpClient
    ) {
        this.customerAdminUri = this.config.backendIwmUri + 'CustomerAdminApi/';
    }

    //#region Template

    public getLists(): Observable<SelectListItem[]> {
        return this.http.get<any>(`${this.customerAdminUri}ListItems?$apply=groupby((Type))`)
            .pipe(pluck('value'));
    }

    public getListValues(listType: string): Observable<SelectListItem[]> {
        const uri = `${this.customerAdminUri}ListItems/Default.GetListItemsByType(type='${listType}')`;
        return this.http.get<any>(uri)
            .pipe(pluck('value'));
    }

    public getListValuesForTaskType(listType: string, taskType: string): Observable<SelectListItem[]> {
        const uri = `${this.customerAdminUri}ListItems/Default.GetListItemsByTypeAndTaskType(type='${listType}',taskType='${taskType}')`;
        return this.http.get<any>(uri)
            .pipe(pluck('value'));
    }

    public createListItemRow(listItem: SelectListItem): Observable<SelectListItem> {
        return this.http.post<SelectListItem>(`${this.customerAdminUri}ListItems`, {
            Value: listItem.Value,
            Type: listItem.Type,
            TaskType: listItem.TaskType
        });
    }

    public updateListItem(listItemId: string, listItem: SelectListItem): Observable<void> {
        return this.http.patch<void>(`${this.customerAdminUri}ListItems(${listItemId})`, {
            Value: listItem.Value
        });
    }

    public batchDeleteListItems(listItemIds: string[]): Observable<void> {
        return this.http.post<void>(`${this.customerAdminUri}ListItems/BatchDelete`,
            {listItemIds: listItemIds});
    }

    public deleteListItem(listItemId: string): Observable<void> {
        return this.http.delete<void>(`${this.customerAdminUri}ListItems(${listItemId})`);
    }

    public moveToLocation(elementId: string, newLocation: number) {
        return this.http.post<SelectListItem>(`${this.customerAdminUri}ListItems(${elementId})/Default.ChangeListPosition`, {
            Position: newLocation
        });
    }

}
